import noop from 'lodash/noop'

import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    AccountResponse,
} from 'app/Apps/AccountManagement/Accounts/Account.types'

import getAccountFields from '../Account.fields'

type Props = {
    data?: AccountResponse,
    onSuccess?: (props: any) => void,
    onCancel?: (...args: any[]) => void,
    requestParam: RequestConfig,
    disabled?: boolean,
    customButtons?: JSX.Element[],
}

const defaultProps: Partial<Props> = {
    data: {} as AccountResponse,
    onSuccess: noop,
    onCancel: noop,
    disabled: false,
    customButtons: [],
}

const AccountForm = ({
    data,
    onSuccess,
    onCancel,
    requestParam,
    disabled,
    customButtons,
}: Props) => {
    const getAllowedValues = useEnumValues()
    const exists = !!data?.id

    return (
        <FormWithControls
            onSuccess={onSuccess}
            value={data}
            name="Account"
            fields={getAccountFields({
                getAllowedValues,
                exists,
                accountLinkAsExtenal: exists && disabled,
                accountPlanLink: data.accountPlanLink,
            })}
            requestParams={requestParam}
            exists={exists}
            onCancel={onCancel}
            disabled={disabled}
            customButtons={customButtons}
        />
    )
}

AccountForm.defaultProps = defaultProps

export default AccountForm
